// extracted by mini-css-extract-plugin
export default {"list":"oBjG8X8wRS"};